import PropTypes from 'prop-types'

export const commonRoleBasedContentInputs = [
    {
        name: 'hideInEdit',
        type: 'boolean',
        defaultValue: false
    }
]

export const commonRoleBasedContentPropTypes = {
    children: PropTypes.node,
    hideInEdit: PropTypes.bool
}

export const getDefaultChildren = (type) => [
    {
        '@type': '@builder.io/sdk:Element',
        component: {
            name: 'Heading',
            options: {
                tag: 'h6',
                variant: 'h6',
                content: `${type} Content`
            }
        },
        responsiveStyles: {
            large: {
                marginTop: '20px'
            }
        }
    }
]
